import React from "react";
import {
    Box,
    Typography,
    IconButton,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';

import { Button,TextField  } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { Divider } from '@material-ui/core';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import TopToolbar from '../global/subcomponents/topToolbar/TopToolbar';
import { INVENTORY_COUNT } from './constants';
import SaveIcon from '@material-ui/icons/Save';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import AutoModeIcon from '@mui/icons-material/AutoMode';

class InventoryCount extends React.Component {
  state = {
    showGenerateDialog: false,
    generateConfig: {
      start: '',
      end: '',
      bays: '',
      levels: '',
    },
    expandedAisles: {},
    aisles: [],
  };

  componentDidMount() {
    this.props.listAllAisle({shipAddressId: this.props.locationId});
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
   if (prevProps.aisle !== this.props.aisle) {
       this.setState({aisles: this.props.aisle})
   }

  }

  toggleAisleExpansion = (index) => {
    this.setState((prev) => ({
      expandedAisles: {
        ...prev.expandedAisles,
        [index]: !prev.expandedAisles[index],
      },
    }));
  };

  handleGenerateInputChange = (field, value) => {
    this.setState((prev) => ({
      generateConfig: {
        ...prev.generateConfig,
        [field]: value,
      },
    }));
  };

  handleOpenGenerateDialog = () => {
    this.setState({ showGenerateDialog: true });
  };

  handleCloseGenerateDialog = () => {
    this.setState({
      showGenerateDialog: false,
      generateConfig: { aisles: '', bays: '', levels: '' },
    });
  };

  submitGenerateDialog = () => {
    const { start, end, bays, levels } = this.state.generateConfig;
    const existingAisles = this.state.aisles.map((a) => a.name);

    const startNum = parseInt(start, 10);
    const endNum = parseInt(end, 10);
    const numBays = parseInt(bays, 10);
    const numLevels = parseInt(levels, 10);

    if (
      isNaN(startNum) ||
      isNaN(endNum) ||
      isNaN(numBays) ||
      isNaN(numLevels) ||
      startNum <= 0 ||
      endNum <= 0 ||
      endNum < startNum ||
      numBays <= 0 ||
      numLevels <= 0
    ) {
      return;
    }

    const newAisles = [];

    for (let i = startNum; i <= endNum; i++) {
      const aisleName = `Aisle ${i}`;

      if (existingAisles.includes(aisleName)) continue; // Skip duplicates

      const baysArr = [];

      for (let j = 0; j < numBays; j++) {
        const levelsArr = [];

        for (let k = 0; k < numLevels; k++) {
          levelsArr.push(`Level ${k + 1}`);
        }

        baysArr.push({
          name: `Bay ${String.fromCharCode(65 + j)}`,
          levels: levelsArr,
        });
      }

      newAisles.push({
        name: aisleName,
        bays: baysArr,
      });
    }

    this.setState((prev) => ({
      aisles: [...prev.aisles, ...newAisles],
      showGenerateDialog: false,
      generateConfig: { start: '', end: '', bays: '', levels: '' },
    }));
  };

  addAisle = () => {
    this.setState((prev) => {
      const newIndex = prev.aisles.length; // index of new aisle
      return {
        aisles: [
          ...prev.aisles,
          {
            name: `Aisle ${prev.aisles.length + 1}`,
            bays: [],
          },
        ],
        expandedAisles: {
          ...prev.expandedAisles,
          [newIndex]: true, // expand newly added aisle
        },
      };
    });
  };

  removeAisle = (aisleIndex) => {
    this.setState((prev) => ({
      aisles: prev.aisles.filter((_, i) => i !== aisleIndex),
    }));
  };

  addBay = (aisleIndex) => {
    const newBay = {
      name: `Bay ${String.fromCharCode(
        65 + this.state.aisles[aisleIndex].bays.length
      )}`,
      levels: [],
    };
    const aisles = [...this.state.aisles];
    aisles[aisleIndex].bays.push(newBay);
    this.setState({ aisles });
  };

  removeBay = (aisleIndex, bayIndex) => {
    const aisles = [...this.state.aisles];
    aisles[aisleIndex].bays.splice(bayIndex, 1);
    this.setState({ aisles });
  };

  addLevel = (aisleIndex, bayIndex) => {
    const aisles = [...this.state.aisles];
    aisles[aisleIndex].bays[bayIndex].levels.push(
      `Level ${aisles[aisleIndex].bays[bayIndex].levels.length + 1}`
    );
    this.setState({ aisles });
  };

  removeLevel = (aisleIndex, bayIndex, levelIndex) => {
    const aisles = [...this.state.aisles];
    aisles[aisleIndex].bays[bayIndex].levels.splice(levelIndex, 1);
    this.setState({ aisles });
  };

  getContextualMenuItems = () => {
    let menuItems = [];
    menuItems.push(
      {
        title: 'Back to menu',
        icon: <KeyboardBackspaceIcon />,
        onClick: () => {
          this.props.handleClose();
        },
      },

      {
        title: 'Auto Generate Aisles',
        icon: <AutoModeIcon />,
        onClick: this.handleOpenGenerateDialog,
      },

      {
        title: 'Save',
        icon: <SaveIcon />,
        onClick: () => {
          this.props.saveAisle({shipAddressId: this.props.locationId, aisles: this.state.aisles });
          this.props.handleClose();
        },
      }
    );
    return menuItems;
  };

  render() {
    return (
      <>
        <TopToolbar
          pageName={INVENTORY_COUNT}
          menuItems={this.getContextualMenuItems()}
        />

        <Dialog
          open={this.state.showGenerateDialog}
          onClose={this.handleCloseGenerateDialog}
        >
          <DialogTitle>Auto Generate Aisles</DialogTitle>
          <DialogContent>
            <div className="rowSpecSuppliers">
              <TextField
                style={{ marginTop: 16, marginRight: '8px' }}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                label="Start Aisle Number"
                type="number"
                fullWidth
                value={this.state.generateConfig.start}
                onChange={(e) =>
                  this.handleGenerateInputChange('start', e.target.value)
                }
              />
              <TextField
                variant="outlined"
                style={{ marginTop: 16, marginLeft: '8px' }}
                InputLabelProps={{ shrink: true }}
                label="End Aisle Number"
                type="number"
                fullWidth
                value={this.state.generateConfig.end}
                onChange={(e) =>
                  this.handleGenerateInputChange('end', e.target.value)
                }
              />
            </div>
            <TextField
              style={{ marginTop: 20 }}
              variant="outlined"
              label="Bays per Aisle"
              InputLabelProps={{ shrink: true }}
              type="number"
              fullWidth
              value={this.state.generateConfig.bays}
              onChange={(e) =>
                this.handleGenerateInputChange('bays', e.target.value)
              }
            />
            <TextField
              style={{ marginTop: 20 }}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              label="Levels per Bay"
              type="number"
              fullWidth
              value={this.state.generateConfig.levels}
              onChange={(e) =>
                this.handleGenerateInputChange('levels', e.target.value)
              }
            />
          </DialogContent>
          <DialogActions style={{ marginRight: '16px', marginBottom: '16px' }}>
            <Button
              variant="contained"
              onClick={this.handleCloseGenerateDialog}
            >
              Cancel
            </Button>
            <div className="save-spacing" />
            <Button
              variant="contained"
              color="primary"
              onClick={this.submitGenerateDialog}
            >
              Generate
            </Button>
          </DialogActions>
        </Dialog>
        <div
          style={{
            marginTop: '50px',
            marginLeft: '50px',
            marginRight: '50px',
            marginBottom: '24px',
          }}
        >
          {this.state.aisles.map((aisle, aisleIndex) => {
            const isExpanded = this.state.expandedAisles[aisleIndex] || false;
            return (
              <Box key={aisleIndex} mb={3}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton
                    size="small"
                    onClick={() => this.toggleAisleExpansion(aisleIndex)}
                  >
                    {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                  <Typography variant="h5">{aisle.name}</Typography>
                  <IconButton
                    onClick={() => this.removeAisle(aisleIndex)}
                    color="error"
                    size="small"
                  >
                    <RemoveCircleIcon fontSize="small" color="error" />
                  </IconButton>
                </Stack>
                {isExpanded && (
                  <Box ml={8} style={{ marginTop: '8px' }}>
                    {aisle.bays.map((bay, bayIndex) => (
                      <Box key={bayIndex} mb={1}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Typography variant="h6">{bay.name}</Typography>
                          <IconButton
                            onClick={() => this.removeBay(aisleIndex, bayIndex)}
                            color="error"
                            size="small"
                          >
                            <RemoveCircleIcon fontSize="small" color="error" />
                          </IconButton>
                        </Stack>
                        <Box ml={3}>
                          {bay.levels.map((level, levelIndex) => (
                            <Stack
                              style={{ marginTop: '12px' }}
                              direction="row"
                              alignItems="center"
                              spacing={1}
                              key={levelIndex}
                            >
                              <Typography variant="body1">{level}</Typography>
                              <IconButton
                                onClick={() =>
                                  this.removeLevel(
                                    aisleIndex,
                                    bayIndex,
                                    levelIndex
                                  )
                                }
                                color="error"
                                size="small"
                              >
                                <RemoveCircleIcon
                                  fontSize="small"
                                  color="error"
                                />
                              </IconButton>
                            </Stack>
                          ))}

                            <Divider
                              style={{
                               marginLeft: '0px',
                                marginTop: '8px',
                                width: '140px',
                              }}
                            />

                             <Button
                              style={{ color: 'black', marginTop: '8px' }}
                              onClick={() => this.addLevel(aisleIndex, bayIndex)}
                              startIcon={
                                <IconButton>
                                  <AddCircleIcon fontSize="medium" color="secondary" />
                                </IconButton>
                              }
                              size="small"
                              sx={{ mt: 1 }}
                            >
                              Add Level
                            </Button>
                        </Box>
                      </Box>
                    ))}

                      <Divider
                              style={{
                               marginLeft: '0px',
                                marginTop: '8px',
                                width: '140px',
                              }}
                            />
                    <Button
                      style={{ color: 'black', marginTop: '8px' }}
                      onClick={() => this.addBay(aisleIndex)}
                      startIcon={
                        <IconButton>
                          <AddCircleIcon fontSize="medium" color="secondary" />
                        </IconButton>
                      }
                      size="small"
                      sx={{ mt: 1 }}
                    >
                      Add Bay
                    </Button>
                  </Box>
                )}
                <Divider
                  style={{
                    marginTop: '8px',
                    marginLeft: '16px',
                    marginRight: '16px',
                    width: '100%',
                  }}
                />
              </Box>
            );
          })}

          <Button
            style={{ color: 'black', marginTop: '-16px' }}
            onClick={() => this.addAisle()}
            startIcon={
              <IconButton>
                <AddCircleIcon fontSize="medium" color="secondary" />
              </IconButton>
            }
            size="small"
            sx={{ mt: 1 }}
          >
            Add Aisle
          </Button>
        </div>
      </>
    );
  }
}

export default InventoryCount;
